import { Emit, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import type { IBriefingPage, IResourceModel, IScrapAgent } from '@/shared/model/briefing-widget.model';
import Component from 'vue-class-component';
import BriefingCard from '@/shared/cards/briefing/briefing-card/briefing-card.vue';
import BriefingCardFeatured from '@/shared/cards/briefing/briefing-card-featured/briefing-card-featured.vue';
import BriefingCardFeaturedCompanies from '@/shared/cards/briefing/briefing-card-featured-companies/briefing-card-featured-companies.vue';
import BriefingService from '@/service/briefing.service';
import { namespace } from 'vuex-class';
import { formatDateAgo, convertDate } from '../../../util/date-util';
import { makeReportTypeText } from '@/util/common-util';
import { map2ResourceItem } from '@/util/mapper-utils';
import DiscoveryAndReportService from '@/service/discoveryAndReport.service';
import UserMyPageService from '@/service/userMyPage.service';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import AddSocialAgent from '@/v2/components/briefing-agent/modal/add-social-agent/add-social-agent.vue';
import AddCompanyAgent from '@/v2/components/briefing-agent/modal/add-company-agent/add-company-agent.vue';
import CompanyBriefingAgentCard from '@/v2/components/briefing-agent/modal/add-company-agent/briefing-company-card.vue';
import { isNullish } from '@/util/ds-util';
import PopupSelectTypeReference from '@/entities/briefing/reference/popup-select-type-reference/popup-select-type-reference.vue';
import { checkIsGuestAccount } from '@/util/guest-util';
import { REFERENCE_TAB_SELECT } from '@/constants';
import ListLoading from '@/entities/resource-management/list-loading/list-loading.vue';
import { watch } from 'fs';

const briefingStore = namespace('briefingStore');
const appStoreState = namespace('appStore');

@Component({
  methods: { isNullish, convertDate, formatDateAgo, makeReportTypeText },
  computed: {
    moment() {
      return moment;
    },
  },
  components: {
    'list-loading': ListLoading,
    'popup-select-type-reference': PopupSelectTypeReference,
    'briefing-card': BriefingCard,
    'briefing-card-featured': BriefingCardFeatured,
    'briefing-card-featured-company': BriefingCardFeaturedCompanies,
    'add-social-agent': AddSocialAgent,
    'add-company-agent': AddCompanyAgent,
    'company-briefing-agent-card': CompanyBriefingAgentCard,
  },
})
export default class SocialBriefingListView extends Vue {
  @Prop(Array) briefingPages: IBriefingPage[] | [];
  @Prop(Boolean) readonly loadMoreAble: boolean;
  // @Prop(Boolean) readonly isEditMode: boolean;
  @Prop(Boolean) readonly hideSettingMode: boolean;
  isEditMode = false;
  isShowEditButton = true;
  currentPage = 0;
  routeName = '';
  customSwitch = 'customSwitch';
  totalCard = 0;
  swiperMyAgent = 'myAgentSwiper';
  swiperSocialAgent = 'socialAgentSwiper';
  isOpenAddSocial = false;
  keyword = '';
  isSearchMode = false;
  searchResults = [];
  requestId = '';
  loading = false;
  isNoData = false;

  isOpenAddCompany = false;
  openSelectTypeReference = false;

  @Emit('load-more') loadMore() {}

  @Emit('loading-complete') loadingComplete() {}

  @Inject('briefingService')
  private briefingService: () => BriefingService;

  @Inject('discoveryService')
  public discoveryService: () => DiscoveryAndReportService;

  @Inject('userMyPageService')
  private userMyPageService: () => UserMyPageService;

  @briefingStore.Mutation
  public setSelectedResource!: (payload: IResourceModel) => void;
  @appStoreState.Mutation
  public setShowDetailReport!: (b: boolean) => void;
  @appStoreState.Mutation
  public setShowDetailArticles!: (b: boolean) => void;
  @appStoreState.Mutation
  public setShowDetailTopic!: (b: boolean) => void;
  @briefingStore.Getter
  public getSelectedResource!: IResourceModel;
  @briefingStore.Getter
  public getSocialPages!: IBriefingPage[];

  @briefingStore.Getter
  public getFeaturedPages!: IBriefingPage[];

  @briefingStore.Mutation
  public setFeaturedCompanies: (payload: IResourceModel[]) => void;

  @briefingStore.Getter
  public getFeaturedCompanies!: IResourceModel[];

  @briefingStore.Getter
  public getTotalBriefingPages!: number;

  @briefingStore.Getter
  public getTotalSubscribeCompany!: number;

  @briefingStore.Mutation
  public setSocialPages: (payload: IBriefingPage[]) => void;

  @briefingStore.Mutation
  public setIsSubscribedBriefing: (payload: boolean) => void;

  @briefingStore.Mutation
  public setFeaturedPages: (payload: IBriefingPage[]) => void;

  @briefingStore.Mutation
  public setTotalSubscribeBriefing: (payload: number) => void;

  @appStoreState.Mutation
  public setShowAddReference!: (isShowAddReference: boolean) => void;

  @briefingStore.Mutation
  public setReferenceDocumentsForNewBriefing!: (payload: any[]) => void;

  @briefingStore.Mutation
  public setIsForNewBriefing!: (payload: boolean) => void;

  @briefingStore.Getter
  public getTotalSubscribeBriefing: number;

  @briefingStore.Getter
  public getRecommendationPages!: IBriefingPage[];

  @briefingStore.Mutation
  public setCompanyPages: (payload: IBriefingPage[]) => void;

  @briefingStore.Getter
  public getCompanyPages!: IBriefingPage[];

  @briefingStore.Getter
  public getDailyBriefingAgent!: IScrapAgent;

  @briefingStore.Getter
  public getNewestRecap!: any;

  @briefingStore.Getter
  public getWeeklyBriefingAgent!: IScrapAgent;

  @briefingStore.Mutation
  public setTotalSubscribeCompany: (payload: number) => void;

  @briefingStore.Mutation
  setSelectedReferenceTab!: (payload: string) => void;

  @briefingStore.Getter
  public getIsSearchingBriefingAgent!: boolean;

  @briefingStore.Mutation
  public setIsSearchingBriefingAgent!: (payload: boolean) => void;

  @appStoreState.Getter
  public getIsShowDeleteBriefing!: boolean;

  mounted() {
    this.requestId = uuidv4();
  }

  deactivated() {
    this.openSelectTypeReference = false;
  }

  @Emit('select')
  select(item: IBriefingPage) {
    return item;
  }

  @Emit('select-recap')
  selectRecap(item) {
    return item;
  }

  @Watch('isEditMode')
  onChangeEditMode(newValue: boolean) {
    this.$emit('editModeList', newValue);
  }

  @Watch('$route.name', { immediate: true })
  async onChangeRouteName(newValue: string) {
    this.routeName = newValue;
    await this.getTotalPages(this.routeName);
    if (newValue === 'MyBriefing-All') {
      this.keyword = '';
      this.handleSearch();
    }
    this.isEditMode = false;
  }

  @Watch('getTotalBriefingPages')
  async onChangeTotalBriefingPages() {
    await this.getTotalPages(this.$route.name);
  }

  @Watch('getTotalSubscribeBriefing')
  async onChangeTotalSubscribeBriefing() {
    await this.getTotalPages(this.$route.name);
  }

  @Watch('getTotalSubscribeCompany')
  async onChangeTotalSubscribeCompany() {
    await this.getTotalPages(this.$route.name);
  }

  @Watch('getIsShowDeleteBriefing')
  onIsShowDeleteBriefingchange(newValue: boolean) {
    this.isEditMode = this.getIsShowDeleteBriefing;
  }

  get uniqueBriefingPages() {
    if (!this.briefingPages || !this.briefingPages.length) {
      return [];
    }
    const seenIds = new Set<string>();
    return this.briefingPages.filter((page: IBriefingPage) => {
      if (!page.bpId) return false;

      if (seenIds.has(page.bpId)) {
        return false;
      }

      seenIds.add(page.bpId);
      return true;
    });
  }

  get displayBriefingPages() {
    if (this.isSearchMode) {
      return this.searchResults;
    }
    return this.uniqueBriefingPages.sort((a, b) => new Date(b.modifyDate).getTime() - new Date(a.modifyDate).getTime());
  }

  @Watch('$route', { immediate: true, deep: true })
  onRouteChange() {
    this.keyword = '';
    this.isSearchMode = false;
  }

  handleSearch() {
    this.isNoData = false;
    const isKeywordEmpty = !this.keyword || this.keyword.trim() === '';
    if (isKeywordEmpty) {
      this.isSearchMode = false;
      this.isNoData = false;
      this.setIsSearchingBriefingAgent(false);
      this.loadingComplete();
      return;
    }
    this.initializeSearch();
    this.setIsSearchingBriefingAgent(true);
    if (this.routeName === 'MyBriefing-All') {
      this.searchMyBriefings();
    } else {
      this.searchSubscribedBriefings();
    }
  }

  viewDetail(item) {
    this.setSelectedResource(item);
    const language = this.$store.getters.currentLanguage ? this.$store.getters.currentLanguage : '';
    switch (item.type) {
      case 'REPORT':
        this.setShowDetailReport(true);
        this.userMyPageService().saveUserActivitiesOpenReportDetail(item.docId, language);
        break;
      case 'TOPIC_SUMMARY':
        this.setShowDetailTopic(true);
        break;
      case 'VIDEO':
        if (this.getSelectedResource?.isShowSourceReference) {
          window.open(item.url, '_blank');
        } else {
          this.setShowDetailArticles(true);
        }
        break;
      default:
        this.setShowDetailArticles(true);
        break;
    }
  }

  private initializeSearch() {
    this.searchResults = [];
    this.isSearchMode = true;
    this.loading = true;
  }

  private searchMyBriefings() {
    this.loading = true;
    const searchType = 'BRIEFING_PAGE';
    const userKey = this.$store.getters?.userIdentity?.id;

    this.briefingService()
      .getAllBriefingPage(userKey, true, null, 0, 999, null, this.keyword, this.requestId, null, searchType)
      .then(response => {
        const data = response.data;
        if (data?.success && data?.body?.briefingPageList) {
          this.processSearchResults(data.body.briefingPageList, 'MY_BRIEFING');
        } else {
          this.handleEmptyResults();
        }
      })
      .catch(this.handleSearchError)
      .finally(() => {
        this.loading = false;
        this.loadingComplete();
      });
  }

  private searchSubscribedBriefings() {
    this.loading = true;
    const searchType = 'BRIEFING_PAGE';
    const requestId = new Date().getTime().toString();
    this.briefingService()
      .getSubscribeBriefingPage(null, searchType, null, 0, 999, this.keyword, requestId)
      .then(response => {
        const data = response.data?.body?.body;
        if (data?.socialBriefingPageList) {
          this.processSearchResults(data.socialBriefingPageList, 'SOCIAL_BRIEFING');
        } else {
          this.handleEmptyResults();
        }
      })
      .catch(this.handleSearchError)
      .finally(() => {
        this.loading = false;
        this.loadingComplete();
      });
  }

  private processSearchResults(results: any[], type: string) {
    this.searchResults = results.map(item => ({
      ...item,
      bpType: type,
    }));
    this.isNoData = this.searchResults.length === 0;
    this.setIsSearchingBriefingAgent(true);
  }

  private handleEmptyResults() {
    this.searchResults = [];
    this.isNoData = true;
    this.setIsSearchingBriefingAgent(true);
  }

  private handleSearchError = (error: any) => {
    console.error('Error searching briefings:', error);
    this.searchResults = [];
    this.isNoData = true;
    this.setIsSearchingBriefingAgent(true);
  };

  handleToggleSubscribed({ payload, index, routeName }) {
    this.toggleSubscribed(payload, index, routeName);
  }

  async toggleSubscribed(payload: IBriefingPage, index: number, routeName: string) {
    if (checkIsGuestAccount(true)) {
      return;
    }

    if (routeName === 'CompanyBriefing-All') {
      // console.log('toggleSubscribedCompany')
      await this.toggleSubscribedCompany(payload, index);
      await this.getTotalPages(routeName);
    } else if (routeName === 'SocialBriefing-All' || routeName === 'SocialUser') {
      // console.log('toggleSubscribedSocial')
      await this.toggleSubscribedSocial(payload, index);
      await this.getTotalPages(routeName);
    }
  }

  async toggleSubscribedCompany(payload: IBriefingPage, index: number) {
    const toggleStatus = payload.subscribeStatus === 'SUBSCRIBE' ? 'UN_SUBSCRIBE' : 'SUBSCRIBE';
    const subscribeCount = payload.subscribeCount + (payload.subscribeStatus === 'SUBSCRIBE' ? -1 : 1);
    Vue.set(this.briefingPages[index], 'updatingSubscribe', true);
    await this.briefingService()
      .updateSubscribeBriefingPage(payload.bpId, toggleStatus)
      .then(response => {
        /* update view */
        Vue.set(this.briefingPages[index], 'subscribeStatus', toggleStatus);
        Vue.set(this.briefingPages[index], 'subscribeCount', subscribeCount);
        /* update in store */
        switch (toggleStatus) {
          case 'SUBSCRIBE': {
            const featuredStore = this.getFeaturedCompanies.findIndex(e => e.bpId === payload.bpId);
            if (featuredStore >= 0) {
              this.getFeaturedCompanies.splice(featuredStore, 1);
            }
            this.getCompanyPages.unshift({
              ...payload,
              updatingSubscribe: false,
              subscribeStatus: toggleStatus,
              subscribeCount: subscribeCount,
            });
            // this.setIsSubscribedBriefing(true);
            this.setTotalSubscribeCompany(this.getTotalSubscribeCompany + 1);
            break;
          }
          case 'UN_SUBSCRIBE': {
            const indexStore = this.getCompanyPages.findIndex(e => e.bpId === payload.bpId);
            if (indexStore >= 0) {
              this.getCompanyPages.splice(indexStore, 1);
            }
            this.setTotalSubscribeCompany(this.getTotalSubscribeCompany - 1);
            this.setIsSubscribedBriefing(false);
            break;
          }
        }
        this.setFeaturedCompanies(this.getFeaturedCompanies);
        this.setCompanyPages(this.getCompanyPages);
      })
      .catch(error => {
        const err = error.response.data;
        const message =
          err.errorCode === 1008
            ? this.$t('briefing.label.error-subscribe-briefing-private').toString()
            : this.$t('newLearningCenter.unknownError').toString();
        this.$bvToast.toast(message, {
          toaster: 'b-toaster-bottom-right',
          title: this.$t('briefing.label.error').toString(),
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
        });
      })
      .finally(() => {
        // Set the button back to inactive (enabled) state
        // Vue.set(this.briefingPages[index], 'updatingSubscribe', false);
      });
  }

  async toggleSubscribedSocial(payload: IBriefingPage, index: number) {
    const toggleStatus = payload.subscribeStatus === 'SUBSCRIBE' ? 'UN_SUBSCRIBE' : 'SUBSCRIBE';
    const subscribeCount = payload.subscribeCount + (payload.subscribeStatus === 'SUBSCRIBE' ? -1 : 1);
    Vue.set(this.briefingPages[index], 'updatingSubscribe', true);
    await this.briefingService()
      .updateSubscribeBriefingPage(payload.bpId, toggleStatus)
      .then(response => {
        /* update view */
        Vue.set(this.briefingPages[index], 'subscribeStatus', toggleStatus);
        Vue.set(this.briefingPages[index], 'subscribeCount', subscribeCount);
        /* update in store */

        if (this.isSearchMode) {
          const searchIndex = this.searchResults.findIndex(item => item.bpId === payload.bpId);
          if (searchIndex >= 0) {
            this.searchResults.splice(searchIndex, 1);
          }
        }
        switch (toggleStatus) {
          case 'SUBSCRIBE': {
            const featuredStore = this.getFeaturedPages.findIndex(e => e.bpId === payload.bpId);
            if (featuredStore >= 0) {
              this.getFeaturedPages.splice(featuredStore, 1);
            }
            this.getSocialPages.unshift({
              ...payload,
              updatingSubscribe: false,
              subscribeStatus: toggleStatus,
              subscribeCount: subscribeCount,
            });
            // this.setIsSubscribedBriefing(true);
            this.setTotalSubscribeBriefing(this.getTotalSubscribeBriefing + 1);
            break;
          }
          case 'UN_SUBSCRIBE': {
            const indexStore = this.getSocialPages.findIndex(e => e.bpId === payload.bpId);
            if (indexStore >= 0) {
              this.getSocialPages.splice(indexStore, 1);
            }
            this.getFeaturedPages.unshift({
              ...payload,
              updatingSubscribe: false,
              subscribeStatus: toggleStatus,
              subscribeCount: subscribeCount,
            });
            this.setTotalSubscribeBriefing(this.getTotalSubscribeBriefing - 1);
            this.setIsSubscribedBriefing(false);
            break;
          }
        }
        this.setFeaturedPages(this.getFeaturedPages);
        this.setSocialPages(this.getSocialPages);
      })
      .catch(error => {
        const err = error.response.data;
        const message =
          err.errorCode === 1008
            ? this.$t('briefing.label.error-subscribe-briefing-private').toString()
            : this.$t('newLearningCenter.unknownError').toString();
        this.$bvToast.toast(message, {
          toaster: 'b-toaster-bottom-right',
          title: this.$t('briefing.label.error').toString(),
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000,
        });
      })
      .finally(() => {
        // Set the button back to inactive (enabled) state
        // Vue.set(this.briefingPages[index], 'updatingSubscribe', false);
      });
  }

  onSelectUserSocial(agentKey: string) {
    const userKey = this.$store.getters?.userIdentity?.id;
    if (userKey === agentKey) {
      this.$router.push('/my-briefing');
    } else {
      this.$router.push(`/social-user/${agentKey}`);
    }
  }

  handleDeleteBriefings() {
    this.$emit('handleDeleteBriefings');
  }

  handleOpenPopupAddBriefingForNewBriefing(event?: any) {
    if (checkIsGuestAccount(true)) {
      event?.stopPropagation();
      event?.preventDefault();

      return;
    }

    this.openSelectTypeReference = true;
  }

  back() {
    this.currentPage--;
  }

  next() {
    this.currentPage++;
  }

  async getTotalPages(routeName: string) {
    switch (routeName) {
      case 'MyBriefing-All':
        this.totalCard = this.getTotalBriefingPages;
        break;
      case 'SocialBriefing-All':
        this.totalCard = this.getTotalSubscribeBriefing;
        break;
      case 'CompanyBriefing-All':
        this.totalCard = this.getTotalSubscribeCompany;
        break;
      default:
        this.totalCard = 0;
        break;
    }
    // console.log(this.totalCard, 'totalCard');
  }

  handleSelect(item: IBriefingPage) {
    this.select(item);
  }

  async handleSubscribe() {
    // console.log('handleSubscribe')
    await this.getTotalPages(this.routeName);
  }

  onHandleOpenReportDaily(item: any) {
    this.discoveryService()
      .checkDocumentTypeForUserKey(this.$store?.getters?.userIdentity.id, item.doc_id)
      .then(ref => {
        if (ref?.data?.body) {
          this.setSelectedResource({
            docId: item.doc_id,
            type: 'REPORT',
            url: item.url,
            title: item.doc_title,
            thumbnail: item.image_url,
            publishAt: item.published_at,
            isBookmarked: ref.data.body?.is_bookmarked,
          });
          const language = this.$store.getters.currentLanguage ? this.$store.getters.currentLanguage : '';
          this.setShowDetailReport(true);
          this.userMyPageService().saveUserActivitiesOpenReportDetail(item.parentDocDetail?.parent_doc_id[0], language);
        }
      });
  }

  onHandleOpenModal(item: any) {
    this.discoveryService()
      .checkDocumentTypeForUserKey(this.$store?.getters?.userIdentity.id, item.parentDocDetail?.parent_doc_id[0])
      .then(ref => {
        if (ref?.data?.body) {
          this.setSelectedResource({
            ...map2ResourceItem(item),
            isBookmarked: ref.data.body?.is_bookmarked,
          });
          const language = this.$store.getters.currentLanguage ? this.$store.getters.currentLanguage : '';
          switch (item.documentType) {
            case 'REPORT':
              this.setShowDetailReport(true);
              this.userMyPageService().saveUserActivitiesOpenReportDetail(item.parentDocDetail?.parent_doc_id[0], language);
              break;
            default:
              if (item.parentDocDetail?.media_type[0] === 'REPORT' || item.originParentDocDetail?.media_type[0] === 'REPORT') {
                this.setShowDetailReport(true);
                this.userMyPageService().saveUserActivitiesOpenReportDetail(item.parentDocDetail?.parent_doc_id[0], language);
                break;
              }

              this.setShowDetailArticles(true);
              break;
          }
        }
      });
  }

  handleCloseAddSocial() {
    this.isOpenAddSocial = false;
    this.totalCard = this.getTotalSubscribeBriefing;
  }

  handleCloseAddCompany() {
    this.isOpenAddCompany = false;
  }

  onImageError(event) {
    event.target.style.position = 'relative';
    event.target.style.left = '0px';
    event.target.style.top = '0px';
    event.target.style.objectFit = 'cover';
    event.target.src = 'content/images/images_v3/common/go-empty-thumb-sz288.png';
  }

  goToRecap() {
    this.$router.push({
      name: 'MyRecap',
    });
  }

  handleOpenPopupAddReferenceBySelectedReferenceTab(selectedReferenceTabInput: string) {
    if (selectedReferenceTabInput === REFERENCE_TAB_SELECT.MY_SCRAP.toString()) {
      if (checkIsGuestAccount(true)) {
        return;
      }
    }
    if (selectedReferenceTabInput) {
      this.setSelectedReferenceTab(selectedReferenceTabInput);
    }

    setTimeout(() => {
      this.setIsForNewBriefing(true);
      this.setReferenceDocumentsForNewBriefing([]);
      this.setShowAddReference(true);
      this.openSelectTypeReference = false;
    }, 1);
  }
}
